<template>
    <div class="lobby">
        <div class="user clear">
            <div class="avatar"><img src="../assets/avatar.png"/></div>
            <h1>John Smith</h1>
        </div>
        <ul class="menu">
           <li>GROUPS</li>
        </ul>
        <div class="room-list">
            <div class="item room create-new-room">
                <div>
                    <span class="block text-c-info">New Room</span>
                    <button class="create button-large full-width btn-disabled">SELECT CHANNEL <span class="fas fa-caret-down"></span></button>
                </div>
                <div class="room-info">
                    <div class="room-name">Room name</div>
                    <div class="member-count">0 members</div>
                </div>
                <div class="share">
                    <div class="share-button align-left"></div>
                    <div class="title">Share Link</div>
                </div>
                <div class="room-manage">
                    <button class="button-large btn-danger full-width strong capitalize text-size-1">CREATE</button>
                </div>
            </div>
            <div v-for="room in rooms" class="item room">
                <div>
                    <div class="thumbnail">
                        <img :src="room.thumbUrl"/>
                    </div>
                    <div class="pad-sm">
                        <div class="now-playing">NOW PLAYING</div>
                        <div class="title">{{room.name}}</div>
                    </div>
                </div>
                <div class="room-info">
                    <div class="room-name">{{room.roomName}}</div>
                    <div class="member-count">7 members</div>
                    <a href="#" class="link-c-danger text-size-3">Edit</a>
                </div>
                <div class="members">
                    <div class="member away">
                        <div class="head">
                            <img src="../assets/face1.png">
                        </div>
                    </div>
                    <div class="member admin">
                        <div class="head">
                            <img src="../assets/face2.png">
                        </div>
                    </div>
                    <div class="member away">
                        <div class="head">
                            <img src="../assets/face3.png">
                        </div>
                    </div>
                    <div class="member">
                        <div class="head">
                            <img src="../assets/face4.png">
                        </div>
                    </div>
                    <div class="member">
                        <div class="head">
                            <img src="../assets/face5.png">
                        </div>
                    </div>
                    <div class="share" @click="toggleUrlShare({name:'DemoRoom', params:{id:room.roomId}})">
                        <div class="share-button align-left"></div>
                        <!--<div class="title">Share Link</div>-->
                    </div>
                </div>
                <div class="room-manage">
                    <router-link :to="{name:'DemoRoom', params:{id:room.roomId}}" class="button-large btn-danger full-width strong capitalize text-size-1">JOIN</router-link>
                </div>
            </div>
        </div>
        <modal v-if="showShareUrl" @togglemodal="toggleUrlShare">
            <template slot="body">
                <div class="share-url">
                    <div class="pad-n">
                        Copy the room link and send it to up to 5 friends to come join you in the room
                    </div>
                    <div class="pad-n">
                        <label for="shareurl" class="block text-left">
                            ROOM URL
                        </label>
                        <input type="text" :value="shareUrl" id="shareurl" :ref="'shareurl'" class="share-url-input full-width"/>
                    </div>
                    <div class="pad-n">
                        <button class="button-large btn-danger full-width" @click="copyRoomUrlToClipboard">Copy link</button>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>
<script>

    let generateShareUrl = function (location) {
        const a = document.createElement('a');
        a.href = this.$router.resolve(location).href;
        return a.protocol + "//" + a.host  + a.pathname + a.search + a.hash;
    };

    import Modal from "./Modal";
    export default {
        name:'Lobby',
        components: {Modal},
        data() {
            return {
                showShareUrl:false,
                shareUrl: null
            }
        },
        methods: {
            toggleUrlShare: function (data) {
                this.shareUrl = data ? generateShareUrl.call(this, data) : null;
                this.showShareUrl = !this.showShareUrl;
            },
            copyRoomUrlToClipboard: function () {
                var copyText = this.$refs['shareurl'];
                copyText.select();
                document.execCommand("Copy");
            }
        },
        computed: {
            rooms: function () {
                return this.$store.state.user.rooms;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Lobby.vue